(function () {
  function init(root) {
    var items = root.querySelectorAll('[data-sf-item]');
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function (other) {
        if (other === except) return;
        other.classList.remove('is-open');
        var ob = other.querySelector('.sf-faq__q');
        if (ob) ob.setAttribute('aria-expanded', 'false');
        var op = other.querySelector('.sf-faq__a');
        if (op) op.style.maxHeight = '';
      });
    }

    function setOpenHeight(item) {
      var panel = item.querySelector('.sf-faq__a');
      var inner = item.querySelector('.sf-faq__a-inner');
      if (!panel || !inner) return;
      panel.style.maxHeight = inner.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.sf-faq__q');
      var panel = item.querySelector('.sf-faq__a');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        closeAll(item);
        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = '';
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          setOpenHeight(item);
        }
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) setOpenHeight(item);
      });
    }, { passive: true });
  }

  document.querySelectorAll('[data-sf-faq]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-sf-faq]');
    if (r) init(r);
  });
})();
